<template>
	<div class="merchant_content">
		<div class="qr_wrap">
			<!--			qr 스캔 전-->
			<div v-if="!qrOn">
				<div>
					<div class="qr_camera_box">
						<qrcode-stream @decode="onDecode" @init="onInit" />
					</div>
					<p class="catch text_1">
						{{ $t('merchant_management.payment_list.qr_scan') }}
					</p>
				</div>
			</div>

			<!--      qr 스캔 후 -->
			<div v-else>
				<div class="qr_image_box">
					<div class="qr_image">
						<img src="@/assets/images/qr_sample.jpg" alt="qr image" />
					</div>
					<span class="CAMERA" @click="switchTab"></span>
				</div>

				<div class="form_wrap">
					<div class="pb_16">
						<p class="input_label">
							{{ $t('merchant_management.qr_payment.payment_asset') }}
						</p>
						<input type="text" v-model="paymentData.settlementAsset" disabled />
					</div>
					<div class="pb_16">
						<p class="input_label">
							{{ $t('merchant_management.qr_payment.payer') }}
						</p>
						<input type="text" v-model="paymentData.payeeName" disabled />
					</div>
					<div class="pb_16">
						<p class="input_label">
							{{ $t('merchant_management.qr_payment.payment_name') }}
						</p>
						<input type="text" v-model="paymentData.title" @input="enterIme" />
					</div>
					<div>
						<p class="input_label">
							{{ $t('merchant_management.qr_payment.amount') }}
						</p>
						<input type="number" class="amount" v-model="paymentData.amount" />
					</div>

					<button
						class="merchant_button bg_red mt_40"
						:disabled="!filledForm"
						@click="this.payInfoModal = true"
					>
						{{ $t('button.confirm') }}
					</button>
				</div>
			</div>
		</div>
	</div>
	<ModalViewM v-if="payInfoModal" @closeModal="payInfoModal = false">
		<template #title>
			<h3 class="modal_title_m">
				{{ $t('merchant_management.qr_payment.title') }}
			</h3>
		</template>
		<div class="bg_black_box">
			<div class="box_items">
				<div class="box_item">
					<p>{{ $t('merchant_management.qr_payment.payer') }}</p>
					<p>{{ paymentData.payeeName }}</p>
				</div>
				<div class="box_item">
					<p>
						{{ $t('merchant_management.payment_list.detail.payment_assets') }}
					</p>
					<p>{{ paymentData.settlementAsset }}</p>
				</div>
			</div>
			<span class="divide_line"></span>
			<div class="box_items">
				<div class="box_items">
					<div class="box_item">
						<p>{{ $t('merchant_management.qr_payment.amount') }}</p>
						<p class="amount">{{ paymentData.amount }}</p>
					</div>
				</div>
			</div>
		</div>
		<p class="check_info">
			{{ $t('merchant_management.qr_payment.check_payment_information') }}
		</p>
		<button class="merchant_button bg_red" @click="payment">
			{{ $t('merchant_management.qr_payment.payment') }}
		</button>
	</ModalViewM>
	<ModalMessageM
		v-if="messageModal"
		:show-close="false"
		@closeModal="messageModal = false"
	>
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">
			{{ modalStatusMessage }}
		</p>
		<button class="merchant_button bg_red" @click="confirm">
			{{ $t('button.confirm') }}
		</button>
	</ModalMessageM>
</template>

<script>
import { QrcodeStream } from 'vue3-qrcode-reader';
import { mapGetters } from 'vuex';
import ModalViewM from '@/components/Layout/ModalView.m';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import jwt from 'jsonwebtoken';
import { authenticateTransaction, approveTransaction } from '@/api/pg';
import { commonError } from '@/common/dialog';

export default {
	name: 'QrPayment',
	components: { QrcodeStream, ModalViewM, ModalMessageM },
	data() {
		return {
			qrOn: false,
			payInfoModal: false,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			isSuccess: false,
			paymentData: {
				settlementAsset: '',
				payeeName: '',
				amount: '',
				authCode: '',
				title: '',
				apiSignature: this.$store.state.auth.merchantInfo.api_signature,
			},
			token: '',
			merchantId: this.$store.state.auth.merchantInfo.merchant_id,
			merchantSeq: this.$store.state.auth.merchantInfo.seq,
			nonce: '',
		};
	},
	computed: {
		...mapGetters('auth', ['is_logged_in']),
		...mapGetters('assets', ['assets']),
		...mapGetters('account', ['accounts']),
		filledForm() {
			return (
				!!this.paymentData.title &&
				!!this.paymentData.amount &&
				!!this.paymentData.settlementAsset &&
				!!this.paymentData.payeeName
			);
		},
	},
	methods: {
		enterIme(e) {
			this.paymentData.title = e.target.value;
		},
		async onInit(promise) {
			try {
				await promise.then(() => {});
			} catch (error) {
				alert(error);
			}
		},
		onDecode(result) {
			const data = result.split('|');
			this.paymentData.payeeName = data[0];
			this.paymentData.settlementAsset = data[1];
			this.paymentData.authCode = data[2];
			this.qrOn = true;
		},
		switchTab() {
			this.qrOn = !this.qrOn;
		},
		async payment() {
			this.token = jwt.sign(
				{
					tx: {
						xptx_auth_code: this.paymentData.authCode,
						asset_code: this.paymentData.settlementAsset,
						amount: this.paymentData.amount,
						title: this.paymentData.title,
						order_id: 'test',
						payer_name: this.paymentData.payeeName,
					},
				},
				this.paymentData.apiSignature,
			);
			const data = {
				account_seq: '',
				merchant_id: this.merchantId,
				token: this.token,
			};
			await authenticateTransaction(data)
				.then(({ nonce }) => {
					this.nonce = nonce;
					this.approvalTransaction();
				})
				.catch(commonError);
		},
		async approvalTransaction() {
			this.token = jwt.sign(
				{
					info: {
						nonce: this.nonce,
						asset_code: this.paymentData.settlementAsset,
						amount: this.paymentData.amount,
					},
				},
				this.paymentData.apiSignature,
			);
			const data = {
				merchant_id: this.merchantId,
				token: this.token,
			};
			await approveTransaction(data)
				.then(() => {
					this.modalStatusMessage = this.$t('modal.message.complete_payment');
					this.modalIcon = 'success';
					this.messageModal = true;
					this.isSuccess = true;
				})
				.catch(err => {
					this.modalStatusMessage = err.message;
					this.modalIcon = 'error';
					this.messageModal = true;
					this.isSuccess = false;
				});
		},
		confirm() {
			this.messageModal = false;
			if (this.isSuccess === true) {
				this.$router.push({
					name: 'payment-list',
				});
			} else {
				this.$router.go(0);
			}
		},
	},
};
</script>

<style scoped>
input[type='number'] {
	width: 100%;
}
</style>
